/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Archivedat1Inputs */

const en__field_archivedat1 = /** @type {(inputs: _Field_Archivedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived at`)
};

/** @type {(inputs: _Field_Archivedat1Inputs) => LocalizedString} */
const de__field_archivedat1 = en__field_archivedat1;

/**
* | output |
* | --- |
* | "Archived at" |
*
* @param {_Field_Archivedat1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_archivedat1 = /** @type {((inputs?: _Field_Archivedat1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Archivedat1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_archivedat1(inputs)
	return de__field_archivedat1(inputs)
});
export { _field_archivedat1 as "_field_archivedAt" }